import React, { useEffect } from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { useCommonPageContext as useCommonPageContextDI } from '@atlassian/jira-servicedesk-common-page-context';
import { GenericError as ErrorView } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors';
import type { Definition } from '../../../../../../common/types';
import {
	START_CONDITIONS_FIELD_NAME,
	PAUSE_CONDITIONS_FIELD_NAME,
	STOP_CONDITIONS_FIELD_NAME,
} from '../../../../../../common/ui/constants.tsx';
import { useFetchConditionsService } from '../../../../../../services/conditions/index.tsx';
import { ConditionView } from './condition';

type Props = {
	conditions: Definition;
	useCommonPageContext?: typeof useCommonPageContextDI;
};

export const Conditions = ({
	conditions,
	useCommonPageContext = useCommonPageContextDI,
}: Props) => {
	const { baseUrl, projectKey } = useCommonPageContext();
	const {
		data: conditionsList,
		fetch,
		loading,
		error,
	} = useFetchConditionsService({
		// @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
		baseUrl,
		// @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
		projectKey,
	});

	const { start, pause, stop } = conditions;

	useEffect(() => {
		const fetchConditionsList = async () => {
			await fetch();
		};
		fetchConditionsList();
	}, [fetch]);

	if (loading || !conditionsList) {
		return <Spinner />;
	}

	if (error) {
		return <ErrorView />;
	}

	return (
		<>
			<ConditionView
				selectedConditions={start}
				conditionsList={conditionsList.hitConditions}
				listName={START_CONDITIONS_FIELD_NAME}
			/>
			<ConditionView
				selectedConditions={pause}
				conditionsList={conditionsList.matchConditions}
				listName={PAUSE_CONDITIONS_FIELD_NAME}
			/>
			<ConditionView
				selectedConditions={stop}
				conditionsList={conditionsList.hitConditions}
				listName={STOP_CONDITIONS_FIELD_NAME}
			/>
		</>
	);
};
